export function buildRbacRolePath(roleEntityRef: string): string | undefined {
  const [, ref = ''] = roleEntityRef.split(':', 2);
  const [namespace, name] = ref.split('/', 2);
  if (!namespace || !name) {
    return undefined;
  }

  return `/access/rbac/roles/role/${encodeURIComponent(
    namespace,
  )}/${encodeURIComponent(name)}`;
}
